import { Component } from '@angular/core';
import { FieldPermission } from '@app/core/model/client/group';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

const PERMISSION_ICONS: Record<FieldPermission, string> = {
  [FieldPermission.NONE]: 'mdi-eye-off-outline',
  [FieldPermission.READ]: 'mdi-eye-outline',
  [FieldPermission.WRITE_ON_CREATE]: 'mdi-pencil-plus-outline',
  [FieldPermission.WRITE]: 'mdi-pencil-outline'
};

@Component({
  standalone: false,
  selector: 'field-permission-cell-renderer',
  templateUrl: './field-permission-cell-renderer.component.html',
  styleUrls: ['./field-permission-cell-renderer.component.scss']
})
export class FieldPermissionCellRendererComponent implements ICellRendererAngularComp {
  public permissionIcon: string;
  public permissionLabel: string;

  /**
   * Initialise the cell with the icon matching the field's permission and its translated label.
   * @param params Parameters containing the field's permission value and its formatted label.
   */
  public agInit(params: ICellRendererParams<any, FieldPermission>): void {
    this.permissionIcon = PERMISSION_ICONS[params.value];
    this.permissionLabel = params.valueFormatted;
  }

  /**
   * Inform ag-grid to handle refresh logic.
   * @param _ Unused.
   * @return false
   */
  public refresh(_: ICellRendererParams): boolean {
    return false;
  }
}
